import type {ComponentProps, FC} from 'react';

import {Heading} from '@/modules/foundation/components/typography/heading';

import {RadioTile} from '../../form/RadioTile';
import {FormattedItemPrice} from '../../item/FormattedItemPrice';
import type {ItemWithVatTypeFragment} from '../../item/query';

export type CupHolderSelectorProps = {
	maxQuantity: number;
	namePrefix: string;
	legend?: string;
	defaultQuantity: number | null;
	items: ItemWithVatTypeFragment[];
} & ComponentProps<'fieldset'>;

export const CupHolderSelector: FC<CupHolderSelectorProps> = ({
	maxQuantity,
	namePrefix,
	legend,
	defaultQuantity,
	items,
	...rest
}) => {
	return (
		<fieldset {...rest}>
			<Heading size="h3" className="mb-3" asChild>
				<legend>{legend}</legend>
			</Heading>
			<div className="flex flex-wrap gap-4">
				{Array.from({length: maxQuantity}, (_, index) => index + 1).map((quantity) => (
					<RadioTile
						key={quantity}
						name={`${namePrefix}`}
						value={quantity}
						defaultChecked={
							(defaultQuantity === null && quantity === 1) ||
							defaultQuantity === quantity
						}
					>
						{quantity} koppholder{quantity > 1 ? 'e' : ''}{' '}
						{quantity > 1 && items.length > 0 && (
							<>
								(+{' '}
								<FormattedItemPrice
									items={items}
									quantity={quantity - 1} // We charge only for additional cup holders after the first
								></FormattedItemPrice>
								)
							</>
						)}
					</RadioTile>
				))}
			</div>
		</fieldset>
	);
};
